// Import model
import { DataviewCarpetCatalogItemResponse } from '../models/DataviewCarpetCatalogItemResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { CarpetCatalogItem } from '../models/CarpetCatalogItem';
import { DataView } from '../models/DataView';
import { FilterCarpetCatalogItemRequest } from '../models/FilterCarpetCatalogItemRequest';

// Import dependency serializers (for complex types)
import { CarpetCatalogItemSerializer } from './CarpetCatalogItemSerializer';
import { DataViewSerializer } from './DataViewSerializer';
import { FilterCarpetCatalogItemRequestSerializer } from './FilterCarpetCatalogItemRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewCarpetCatalogItemResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewCarpetCatalogItemResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewCarpetCatalogItemResponse instance
   */
  static deserialize(json: string): DataviewCarpetCatalogItemResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewCarpetCatalogItemResponse instance
   */
  static fromObject(obj: any): DataviewCarpetCatalogItemResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewCarpetCatalogItemResponse');
    }


    const instance: DataviewCarpetCatalogItemResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        CarpetCatalogItemSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterCarpetCatalogItemRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewCarpetCatalogItemResponse instances
   */
  static deserializeArray(json: string): DataviewCarpetCatalogItemResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewCarpetCatalogItemResponse instance to a JSON string
   */
  static serialize(instance: DataviewCarpetCatalogItemResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewCarpetCatalogItemResponse instance to a plain object
   */
  static toObject(instance: DataviewCarpetCatalogItemResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        CarpetCatalogItemSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterCarpetCatalogItemRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewCarpetCatalogItemResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewCarpetCatalogItemResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
